export enum PortalType {
  Client,
  Staff,
  Referral,
}
